import { Injectable } from "@angular/core";

import { PrognoseDto, PrognoseLinjeDto } from "../model/prognose.dto";
import { Prognose, PrognoseLinje } from "../model/prognose.model";

@Injectable({ providedIn: "root" })
export class PrognoseMapper {
    public dtoToPrognose(dto: PrognoseDto): Prognose {
        return { linjer: dto.faktlini.map(l => this.dtoToPrognoseLinje(l)) };
    }

    private dtoToPrognoseLinje(dto: PrognoseLinjeDto): PrognoseLinje {
        return this.dtoToPrognoseLinjeBasedOnSplitText(dto) || this.dtoToPrognoseLinjeBasedOnProperties(dto);
    }

    private dtoToPrognoseLinjeBasedOnSplitText(dto: PrognoseLinjeDto): PrognoseLinje {
        const split = (dto.linieType === "0" && dto.tekst.split("¤")) || [];
        if (split.length <= 1) {
            return null;
        }
        return {
            col1: split[0] || "",
            col2: split[1] || "",
            col3: split[2] || "",
            col4: split[3] || "",
            cssClasses: this.getCssClasses(dto)
        };
    }

    private dtoToPrognoseLinjeBasedOnProperties(dto: PrognoseLinjeDto): PrognoseLinje {
        return {
            col1: dto.tekst,
            col2: dto.antalEnheder ? `${dto.antalEnheder} ${dto.enhed}` : `${dto.opl3} ${dto.opl4}`,
            col3: dto.enhedPris ? `${dto.enhedPris} ${dto.prisEnhed}` : "",
            col4: dto.ialt ? `${dto.ialt} ${dto.ekstra}` : "",
            cssClasses: this.getCssClasses(dto)
        };
    }

    private getCssClasses(dto: PrognoseLinjeDto): string {
        if (dto.linieType === "12") {
            return "bold border-top";
        }
        if (dto.linieType === "0" && dto.tekst.split("¤").length > 1) {
            return "bold";
        }
        return "";
    }
}
